import { IDoctor } from "../../interfaces/api";
import SimpleDoctorTile from "./SimpleDoctorTile.component";

const ListSection = ({
  doctors,
  onRemove,
  stepModal,
  showMessage,
}: {
  doctors: IDoctor[];
  onRemove: (providerId: string, npi: string, provider: boolean) => void;
  showMessage: boolean;
  stepModal?: boolean;
}) => {
  if (stepModal === true) {
    return (
      <div
        className="grid-x"
        style={{ overflowY: "auto", maxHeight: "250px", rowGap: 16 }}
      >
        {doctors.map((doctor: IDoctor, index) => (
          <SimpleDoctorTile data={doctor} key={index} onRemove={onRemove} />
        ))}
      </div>
    );
  }
  return (
    <>
      <div
        className="flex-container hide-for-small-only"
        style={{
          padding: "24px 72px 32px 72px",
          flexDirection: "column",
          textAlign: "start",
        }}
      >
        <h2
          className="color-secondary text-uppercase"
          style={{ fontSize: "30px", fontWeight: 600, paddingBottom: "24px" }}
        >
          Your List
        </h2>
        {showMessage && (
          <div
            style={{
              color: "red",
              paddingBottom: 10,
              textAlign: "center",
              fontSize: 18,
            }}
          >
            You may add only one primary care provider. Please remove the
            primary care provider listed below if you would like to update your
            selection.
            <br />
            You may add multiple specialists to your list.
          </div>
        )}
        {doctors.length === 0 ? (
          <>
            <div>It looks like your list is empty.</div>
            <div>Search for your doctors to add them to your list.</div>
          </>
        ) : (
          <div
            className="grid-x"
            style={{ overflowY: "auto", maxHeight: "250px", rowGap: 16 }}
          >
            {doctors.map((doctor: IDoctor, index) => (
              <SimpleDoctorTile data={doctor} key={index} onRemove={onRemove} />
            ))}
          </div>
        )}
      </div>
      <div
        className="flex-container show-for-small-only"
        style={{ padding: "20px", flexDirection: "column", textAlign: "start" }}
      >
        <h2
          className="color-secondary text-uppercase"
          style={{ fontSize: "30px", fontWeight: 600, paddingBottom: "24px" }}
        >
          Your List
        </h2>
        {showMessage && (
          <div
            style={{
              color: "red",
              paddingBottom: 10,
              textAlign: "center",
              fontSize: 18,
            }}
          >
            You may add only one primary care provider. Please remove the
            primary care provider listed below if you would like to update your
            selection.
            <br />
            You may add multiple specialists to your list.
          </div>
        )}
        {doctors.length === 0 ? (
          <>
            <div>It looks like your list is empty.</div>
            <div>Search for your doctors to add them to your list.</div>
          </>
        ) : (
          <div
            className="grid-x"
            style={{ overflowY: "auto", maxHeight: "250px", rowGap: 16 }}
          >
            {doctors.map((doctor: IDoctor, index) => (
              <SimpleDoctorTile data={doctor} key={index} onRemove={onRemove} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default ListSection;
